import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "glores-B-join-wrap glores-B-lan-kr" }
const _hoisted_6 = { class: "glores-B-join-form glores-B-lan-kr" }
const _hoisted_7 = { class: "glores-B-value" }
const _hoisted_8 = { class: "glores-B-value" }
const _hoisted_9 = { class: "glores-B-value" }
const _hoisted_10 = { class: "glores-B-value" }
const _hoisted_11 = { class: "glores-B-join-wrap glores-B-lan-kr" }
const _hoisted_12 = {
  name: "mem_reg_form",
  method: "post",
  action: "",
  target: "ok_frame",
  enctype: "multipart/form-data"
}
const _hoisted_13 = { class: "glores-B-join-form glores-B-lan-kr" }
const _hoisted_14 = { class: "glores-B-value" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "admin-info-message",
  style: {"padding":"20px","text-align":"center","background-color":"#f0f0f0","border-radius":"4px","margin-top":"20px","margin-bottom":"15px"}
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "glores-B-value" }
const _hoisted_20 = { class: "reg_name" }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { class: "glores-B-value" }
const _hoisted_23 = { class: "reg_email" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { class: "glores-B-value" }
const _hoisted_27 = { class: "reg_mobileNumber" }
const _hoisted_28 = { key: 5 }
const _hoisted_29 = { class: "glores-B-value" }
const _hoisted_30 = { key: 6 }
const _hoisted_31 = { class: "glores-B-value" }
const _hoisted_32 = { key: 7 }
const _hoisted_33 = { class: "glores-B-value" }
const _hoisted_34 = { class: "glores-B-btn-wrap btn-pc-align-bothside" }
const _hoisted_35 = { class: "btn-align-left" }
const _hoisted_36 = { class: "btn-align-right" }
const _hoisted_37 = { class: "glores-B-mem-modify-btns" }
const _hoisted_38 = {
  key: 0,
  class: "btn-cell"
}
const _hoisted_39 = {
  key: 1,
  class: "btn-cell"
}
const _hoisted_40 = { id: "glores-B-popup-wrap" }
const _hoisted_41 = {
  id: "glores-B-popup-contents",
  class: "glores-B-pwd-change-wrap",
  style: {"padding":"17px 16px 20px","position":"relative"}
}
const _hoisted_42 = {
  key: 0,
  class: "modal-loading-overlay",
  style: {"position":"absolute","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(255, 255, 255, 0.8)","display":"flex","justify-content":"center","align-items":"center","z-index":"10"}
}
const _hoisted_43 = { id: "content-container" }
const _hoisted_44 = { class: "glores-B-change-pwd-form-wrap" }
const _hoisted_45 = {
  name: "pwd_ch_form",
  method: "post",
  style: {"margin":"0"}
}
const _hoisted_46 = { class: "glores-B-change-pwd-form" }
const _hoisted_47 = { class: "glores-B-popup-bt-btns" }

import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import {
  NIcon,
  NButton,
  NSpin,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui"; // useMessage 임포트
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRoute, useRouter } from "vue-router";
import { firebaseAuth, getCallable } from "@/config/env";
import { useAuth } from "@/composables/useAuth";
import * as common from "@/assets/common/common.ts";
import { ref, onMounted, computed } from "vue";
import * as constant from "@/constants/constant";
import { useActionDialog } from "@/composables/useDialog";

export default /*@__PURE__*/_defineComponent({
  __name: 'Modify',
  setup(__props) {

const { show: showActionDialog } = useActionDialog();

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const {
  isLoggedIn,
  loggedInUserId,
  loggedInUserName,
  handleLogout,
  isOrgUser,
  loading,
  isOrgAdmin,
  loginType,
} = useAuth();
const updateMemberInfoCallable = getCallable("updateMemberInfo");
const withdrawUserCallable = getCallable("withdrawUser");

const changeMemberPasswordCallable = getCallable("changeMemberPassword");
const changeOrgUserPasswordCallable = getCallable("changeOrgUserPassword");

const route = useRoute();
const router = useRouter();
const showChangePassword = ref<boolean>(false);
const withdrawLoading = ref<boolean>(false);
// 폼 데이터를 위한 ref (실제 폼 필드에 맞게 구조 정의 필요)
const formData = ref({
  id: "",
  name: "",
  email: "",
  hp1: "",
  hp2: "",
  hp3: "",
  role: "",
  position: "",
  description: "", // 기관 사용자용 기타 설명
  disabled: false,
  org: {
    description: "",
    email: "",

    name: "",
    phoneNumber: "",
  },
});

const changePasswordForm = ref({
  old_password: "",
  new_password: "",
  new_password_confirm: "",
});
// 사용자 유형 판단
const isOrgAdminUser = computed(() => {
  return isOrgAdmin.value;
});

onMounted(() => {
  loading.value = true; // 로딩 시작
  showChangePassword.value = false;
  const authInfo = common.getLocalAuth();
  if (authInfo) {
    if (loginType.value == "user") {
      if (authInfo.type == constant.loginType.CUSTOM) {
        formData.value.id = authInfo.uid.split(":")[1];
      } else {
        formData.value.disabled = true;
        formData.value.id = authInfo.email!;
      }
    }
    formData.value.name = authInfo.name || "";

    formData.value.email = authInfo.email || "";
    if (authInfo.phoneNumber) {
      let hps: string[] = authInfo.phoneNumber?.split("-");
      if (hps.length == 3) {
        formData.value.hp1 = hps[0];
        formData.value.hp2 = hps[1];
        formData.value.hp3 = hps[2];
      }
    }
    if (isOrgUser.value && authInfo.orgId && authInfo.uid) {
      let org = authInfo.org;
      if (org) {
        formData.value.org = org;
      }
      if (!isOrgAdminUser.value) {
        formData.value.role = authInfo.role || "";
        formData.value.position = authInfo.position || "";
        formData.value.description = authInfo.description || "";
      }
    }
  } else {
    console.log("로그인된 사용자 정보가 없습니다.");
  }
  loading.value = false; // 로딩 종료
});

function onChangePasswordModalClose() {
  showChangePassword.value = false;
  changePasswordForm.value = {
    old_password: "",
    new_password: "",
    new_password_confirm: "",
  };
}
const validatePassword = () => {
  let isValid = true;
  // 패스워드 유효성 검사 (8~16자, 영문, 숫자, 특수문자 조합)
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,16}$/;
  if (!changePasswordForm.value.new_password) {
    isValid = false;
  } else if (!passwordRegex.test(changePasswordForm.value.new_password)) {
    notification.error({
      title: "에러",
      description:
        "패스워드는 8~16자의 영문, 숫자, 특수문자를 모두 포함해야 합니다.",
      duration: 1500,
      closable: true,
    });
    isValid = false;
  }
  return isValid;
};
async function changePassword() {
  if (
    changePasswordForm.value.new_password !==
    changePasswordForm.value.new_password_confirm
  ) {
    notification.error({
      title: "에러",
      description: `새 비밀번호와 새 비밀번호 확인이 일치하지 않습니다.`,
      duration: 1500,
      closable: true,
    });
    return;
  }
  // TODO : 비밀번호 정책 정해진 후 아래 주석 해제 및 보완
  if (!validatePassword()) {
    return;
  }
  // TODO: 새 비밀번호에 대한 추가 유효성 검사 (영문, 숫자, 특수문자 조합 등)

  loading.value = true;
  try {
    let result: any;
    const payload = {
      old_password: changePasswordForm.value.old_password,
      new_password: changePasswordForm.value.new_password,
      uid: common.getLocalAuth().uid,
      type: common.getLocalAuth().type,
    };
    if (isOrgUser.value && !isOrgAdminUser.value) {
      const orgUserPayload = {
        ...payload,
        orgId: common.getLocalAuth().orgId,
      };
      result = await changeOrgUserPasswordCallable(orgUserPayload);
    } else if (!isOrgUser.value) {
      // 일반 사용자
      const memberPayload = {
        ...payload,
      };
      result = await changeMemberPasswordCallable(memberPayload);
    } else {
      notification.error({
        title: "에러",
        description: `비밀번호를 변경할 수 없는 사용자 유형입니다.`,
        duration: 1500,
        closable: true,
        onAfterLeave: () => {
          showChangePassword.value = false; // 모달 닫기
        },
      });
      loading.value = false;
      return;
    }
    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "성공",
        description: "비밀번호가 성공적으로 변경되었습니다.",
        duration: 3000,
        closable: true,
        onAfterLeave: () => {
          showChangePassword.value = false; // 모달 닫기
        },
      });
      changePasswordForm.value = {
        old_password: "",
        new_password: "",
        new_password_confirm: "",
      }; // 폼 초기화
    } else {
      console.error("비밀번호 변경 중 오류:", common.getResultError(result));
      notification.error({
        title: "에러",
        description: `비밀번호 변경 실패: ${
          common.getResultError(result) || "오류가 발생했습니다."
        }`,
        duration: 1500,
        closable: true,
      });
    }
  } catch (error: any) {
    console.error("비밀번호 변경 중 오류:", error);
    notification.error({
      title: "에러",
      description: `비밀번호 변경 중 오류가 발생했습니다: ${
        error.message || "알 수 없는 오류"
      }`,
      duration: 1500,
      closable: true,
    });
  } finally {
    loading.value = false;
  }
}

async function updateMemberInfo() {
  showActionDialog({
    title: "확인",
    content: "회원 정보를 변경 하시겠습니까?",
    positiveText: "네",
    negativeText: "아니요",
    positiveButtonProps: { type: "default" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      loading.value = true;
      try {
        const currentAuth = common.getLocalAuth();
        const payload = {
          uid: currentAuth.uid,
          type: currentAuth.type,
          email: formData.value.email,
        } as any;
        if (!isOrgUser.value && !isOrgAdminUser.value) {
          payload.name = formData.value.name;
        }
        const result = await updateMemberInfoCallable(payload);
        if (common.evalFunctionResult(result)) {
          currentAuth.email = formData.value.email; // 변경된 이메일로 업데이트
          if (!isOrgUser.value && !isOrgAdminUser.value) {
            currentAuth.name = formData.value.name;
          }
          common.setLocalAuth(currentAuth);
          notification.success({
            title: "성공",
            description: "정보 변경 성공",
            duration: 1000,
            closable: true,
          });
        } else {
          notification.error({
            title: "에러",
            description: `정보 변경 실패: ${
              common.getResultError(result) || "오류가 발생했습니다."
            }`,
            duration: 1500,
            closable: true,
          });
        }
      } catch (error: any) {
        notification.error({
          title: "에러",
          description: `정보 변경 실패: ${error.message || "알 수 없는 오류"}`,
          duration: 1500,
          closable: true,
        });
      } finally {
        loading.value = false;
      }
    },
    onCancel: () => {
      console.log("canceled update memeber info");
    },
  });
}

async function withdrawUser() {
  showActionDialog({
    title: "확인",
    content: "탈퇴 하시겠습니까?",
    positiveText: "네",
    negativeText: "아니요",
    positiveButtonProps: { type: "error" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      withdrawLoading.value = true;
      try {
        const currentAuth = common.getLocalAuth();
        const payload = {
          uid: currentAuth.uid,
        } as any;

        const result = await withdrawUserCallable(payload);
        if (common.evalFunctionResult(result)) {
          common.removeLocalAuth();
          notification.success({
            title: "성공",
            description: "회원 탈퇴 성공",
            duration: 1000,
            closable: true,
          });
          router.push(USER_ROUTES.Home.Path);
        } else {
          notification.error({
            title: "에러",
            description: `회원 탈퇴 실패: ${
              common.getResultError(result) || "오류가 발생했습니다."
            }`,
            duration: 1500,
            closable: true,
          });
        }
      } catch (error: any) {
        notification.error({
          title: "에러",
          description: `회원 탈퇴 실패: ${error.message || "알 수 없는 오류"}`,
          duration: 1500,
          closable: true,
        });
      } finally {
        withdrawLoading.value = false;
      }
    },
    onCancel: () => {
      console.log("canceled withDraw");
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: _ctx.$route.path.includes(_unref(USER_ROUTES).MYPAGEMODIFY) ? 'etc' : '',
      subtitle: _ctx.$route.path.includes(_unref(USER_ROUTES).MYPAGEMODIFY) ? 'etc' : '',
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }, null, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[34] || (_cache[34] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("회원정보수정"),
          _createElementVNode("span")
        ], -1)),
        (_unref(isOrgUser))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "glores-B-join-form-title glores-B-mgt-none" }, "기관 정보", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("dl", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("dt", null, "기관명", -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(formData.value.org.name), 1)
                    ])
                  ]),
                  _createElementVNode("dl", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("dt", null, "기관 이메일", -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(formData.value.org.email), 1)
                    ])
                  ]),
                  _createElementVNode("dl", null, [
                    _cache[17] || (_cache[17] = _createElementVNode("dt", null, "기관 전화번호", -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(formData.value.org.phoneNumber), 1)
                    ])
                  ]),
                  _createElementVNode("dl", null, [
                    _cache[18] || (_cache[18] = _createElementVNode("dt", null, "기관 설명", -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(formData.value.org.description), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "glores-B-join-form-title" }, "사용자 정보", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("form", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("dl", null, [
                _cache[20] || (_cache[20] = _createElementVNode("dt", null, [
                  _createElementVNode("label", { for: "id" }, "아이디")
                ], -1)),
                _createElementVNode("dd", null, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(formData.value.id), 1)
                ])
              ]),
              (!_unref(isOrgUser))
                ? (_openBlock(), _createElementBlock("dl", _hoisted_15, [
                    _cache[21] || (_cache[21] = _createElementVNode("dt", null, [
                      _createElementVNode("label", { for: "name" }, "이름")
                    ], -1)),
                    _createElementVNode("dd", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "formData.name",
                        id: "formData.name",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                        disabled: formData.value.disabled
                      }, null, 8, _hoisted_16), [
                        [_vModelText, formData.value.name]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(isOrgAdmin))
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 기관 관리자 정보는 수정할 수 없습니다. "))
                : _createCommentVNode("", true),
              (_unref(isOrgUser) && !_unref(isOrgAdmin))
                ? (_openBlock(), _createElementBlock("dl", _hoisted_18, [
                    _cache[22] || (_cache[22] = _createElementVNode("dt", null, [
                      _createElementVNode("label", { for: "name" }, "성명")
                    ], -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "name",
                            id: "name",
                            size: "20",
                            maxlength: "20",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event))
                          }, null, 512), [
                            [_vModelText, formData.value.name]
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_unref(isOrgAdmin) || (_unref(isOrgUser) && !_unref(isOrgAdmin)))
                ? (_openBlock(), _createElementBlock("dl", _hoisted_21, [
                    _cache[24] || (_cache[24] = _createElementVNode("dt", null, [
                      _createElementVNode("label", { for: "email" }, "이메일")
                    ], -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "email",
                            id: "email",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                            disabled: formData.value.disabled
                          }, null, 8, _hoisted_24), [
                            [_vModelText, formData.value.email]
                          ])
                        ])
                      ]),
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "glores-B-info" }, "이메일 주소를 입력하세요.", -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(isOrgUser) && !_unref(isOrgAdmin))
                ? (_openBlock(), _createElementBlock("dl", _hoisted_25, [
                    _cache[27] || (_cache[27] = _createElementVNode("dt", null, [
                      _createElementVNode("label", { for: "hp1" }, "휴대전화")
                    ], -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "hp1",
                            size: "4",
                            maxlength: "4",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.hp1) = $event)),
                            title: "휴대전화 첫번째"
                          }, null, 512), [
                            [_vModelText, formData.value.hp1]
                          ]),
                          _cache[25] || (_cache[25] = _createTextVNode(" - ")),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "hp2",
                            size: "4",
                            maxlength: "4",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.hp2) = $event)),
                            title: "휴대전화 두번째"
                          }, null, 512), [
                            [_vModelText, formData.value.hp2]
                          ]),
                          _cache[26] || (_cache[26] = _createTextVNode(" - ")),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "hp3",
                            size: "4",
                            maxlength: "4",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.hp3) = $event)),
                            title: "휴대전화 세번째"
                          }, null, 512), [
                            [_vModelText, formData.value.hp3]
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(isOrgUser) && !_unref(isOrgAdmin))
                ? (_openBlock(), _createElementBlock("dl", _hoisted_28, [
                    _cache[28] || (_cache[28] = _createElementVNode("dt", null, [
                      _createElementVNode("label", { for: "role" }, "역할")
                    ], -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_29, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "role",
                          id: "role",
                          size: "30",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.role) = $event))
                        }, null, 512), [
                          [_vModelText, formData.value.role]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(isOrgUser) && !_unref(isOrgAdmin))
                ? (_openBlock(), _createElementBlock("dl", _hoisted_30, [
                    _cache[29] || (_cache[29] = _createElementVNode("dt", null, [
                      _createElementVNode("label", { for: "position" }, "직책")
                    ], -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "position",
                          id: "position",
                          size: "30",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.position) = $event))
                        }, null, 512), [
                          [_vModelText, formData.value.position]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(isOrgUser) && !_unref(isOrgAdmin))
                ? (_openBlock(), _createElementBlock("dl", _hoisted_32, [
                    _cache[30] || (_cache[30] = _createElementVNode("dt", null, [
                      _createElementVNode("label", { for: "description" }, "기타 (설명)")
                    ], -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("div", _hoisted_33, [
                        _withDirectives(_createElementVNode("textarea", {
                          name: "description",
                          id: "description",
                          rows: "5",
                          style: {"width":"100%"},
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.description) = $event))
                        }, null, 512), [
                          [_vModelText, formData.value.description]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_unref(NButton), {
                  type: "primary",
                  bordered: false,
                  onClick: updateMemberInfo,
                  loading: _unref(loading),
                  style: {"min-width":"150px","background-color":"#be7b42"},
                  disabled: formData.value.disabled
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode(" 수정 ")
                  ])),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  (
                      (!isOrgAdminUser.value || (_unref(isOrgUser) && !isOrgAdminUser.value)) &&
                      !formData.value.disabled
                    )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(_unref(NButton), {
                          type: "primary",
                          bordered: false,
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (showChangePassword.value = true), ["prevent"])),
                          style: {"min-width":"150px","background-color":"#be7b42"},
                          disabled: formData.value.disabled
                        }, {
                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                            _createTextVNode(" 비밀번호변경 ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  (!_unref(isOrgUser))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_unref(NButton), {
                          type: "primary",
                          bordered: false,
                          onClick: _withModifiers(withdrawUser, ["prevent"]),
                          loading: withdrawLoading.value,
                          style: {"min-width":"150px","background-color":"#be7b42"}
                        }, {
                          default: _withCtx(() => _cache[33] || (_cache[33] = [
                            _createTextVNode(" 회원탈퇴 ")
                          ])),
                          _: 1
                        }, 8, ["loading"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_n_modal, {
      show: showChangePassword.value,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => ((showChangePassword).value = $event)),
      preset: "card",
      style: {"width":"600px"},
      title: "비밀번호 변경",
      onAfterLeave: onChangePasswordModalClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _cache[44] || (_cache[44] = _createElementVNode("div", { id: "glores-B-popup-header" }, [
            _createElementVNode("h1", null, "비밀번호 변경"),
            _createElementVNode("button", {
              type: "button",
              id: "glores-B-popup-h-close",
              onclick: "popup_window_close()"
            }, " 닫기 ")
          ], -1)),
          _createElementVNode("div", _hoisted_41, [
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createVNode(_unref(NSpin), { size: "large" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              _cache[43] || (_cache[43] = _createElementVNode("ul", { class: "glores-B-change-pwd-help" }, [
                _createElementVNode("li", null, " 비밀번호는 연속번호나 전화번호 등 타인이 알기 쉬운 숫자는 되도록 삼가 주십시오. "),
                _createElementVNode("li", null, " 비밀번호는 8자 이상 영문 + 숫자+ 특수문자를 모두 조합해서 입력해주세요. "),
                _createElementVNode("li", null, "비밀번호는 암호화 되어 보관되므로 안심하셔도 됩니다.")
              ], -1)),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("form", _hoisted_45, [
                  _cache[39] || (_cache[39] = _createElementVNode("input", {
                    type: "hidden",
                    name: "this_domain"
                  }, null, -1)),
                  _cache[40] || (_cache[40] = _createElementVNode("input", {
                    type: "hidden",
                    name: "post_action"
                  }, null, -1)),
                  _cache[41] || (_cache[41] = _createElementVNode("input", {
                    type: "hidden",
                    name: "form_sess_id",
                    value: "d101j0c86plfiucktc2r8cal21"
                  }, null, -1)),
                  _cache[42] || (_cache[42] = _createElementVNode("input", {
                    type: "hidden",
                    name: "auth_code",
                    value: ""
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("dl", null, [
                      _cache[36] || (_cache[36] = _createElementVNode("dt", null, [
                        _createElementVNode("label", { for: "glores-B-pwd1" }, "기존 비밀번호")
                      ], -1)),
                      _createElementVNode("dd", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          id: "old_password",
                          class: "glores-B-input-text",
                          name: "pwd",
                          size: "15",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((changePasswordForm.value.old_password) = $event)),
                          maxlength: "15",
                          style: {"width":"100%"}
                        }, null, 512), [
                          [_vModelText, changePasswordForm.value.old_password]
                        ])
                      ])
                    ]),
                    _createElementVNode("dl", null, [
                      _cache[37] || (_cache[37] = _createElementVNode("dt", null, [
                        _createElementVNode("label", { for: "glores-B-pwd2" }, "새 비밀번호")
                      ], -1)),
                      _createElementVNode("dd", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          id: "new_password",
                          class: "glores-B-input-text",
                          name: "new_pwd",
                          size: "15",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((changePasswordForm.value.new_password) = $event)),
                          maxlength: "15",
                          style: {"width":"100%"}
                        }, null, 512), [
                          [_vModelText, changePasswordForm.value.new_password]
                        ])
                      ])
                    ]),
                    _createElementVNode("dl", null, [
                      _cache[38] || (_cache[38] = _createElementVNode("dt", null, [
                        _createElementVNode("label", { for: "glores-B-pwd3" }, "새 비밀번호 확인")
                      ], -1)),
                      _createElementVNode("dd", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          id: "new_password_confirm",
                          class: "glores-B-input-text",
                          name: "new_pwd2",
                          size: "15",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((changePasswordForm.value.new_password_confirm) = $event)),
                          maxlength: "15",
                          style: {"width":"100%"}
                        }, null, 512), [
                          [_vModelText, changePasswordForm.value.new_password_confirm]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("a", {
                    onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (changePassword()), ["prevent"])),
                    href: "#",
                    class: "glores-B-popup-bt-btn-type1 glores-B-full-width glores-B-highlight"
                  }, "비밀번호 변경")
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})